import { PlanFactoryProvider, type IPlanFactoryAuth } from '@redirecthealth/plan-factory-ui';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import type { IHostConfig } from './config';
import { PlanFactoryMount } from './routing/PlanFactoryMount';

function NotFound() {
  const { t } = useTranslation();
  return <p>{t('notFound')}</p>;
}

export function App({ config, auth }: { config: IHostConfig; auth: IPlanFactoryAuth }) {
  return (
    <PlanFactoryProvider
      apiBaseUrl={config.planServiceApiBaseUrl}
      planServiceScope={config.planServiceScope}
      auth={auth}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/plan-factory" replace />} />
        <Route path="/plan-factory/*" element={<PlanFactoryMount />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PlanFactoryProvider>
  );
}
